import React from "react";
import {Check, LoopIcon} from "assets/icons";
import Banner from "components/banner/banner";
import Button from "components/button";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";

const LicenceCatalogueStep = ({
    translate,
    options,
    catalogueStatus,
    searchQuery,
    onSearchChange,
    selectedKey,
    onSelect,
    getLabel,
    onClose,
    onNext,
}) => {
    const canGoNext = Boolean(selectedKey);

    return (
        <>
            <Modalheader hide={onClose} hideShow={true}>
                {translate("title")}
            </Modalheader>
            <ModalBody>
                <div className="flex flex-col gap-4">
                    <p className="ft-sm text-gray-500">{translate("subtitle")}</p>
                    <label className="flex items-center gap-2 h-11 px-3 border border-gray-300 rounded-lg focus-within:border-yellow-500">
                        <LoopIcon wh={18} color={"#9CA3AF"}/>
                        <input
                            type="search"
                            value={searchQuery}
                            onChange={(e) => onSearchChange(e.target.value)}
                            placeholder={translate("search_placeholder")}
                            aria-label={translate("search_placeholder")}
                            className="w-full h-full ft-b text-gray-900 placeholder-gray-400 outline-none border-0 bg-transparent"
                        />
                    </label>
                    {catalogueStatus === "loading" && (
                        <p className="ft-sm text-gray-500" role="status">{translate("catalogue_loading")}</p>
                    )}
                    {catalogueStatus === "error" && <Banner type="alert">{translate("catalogue_error")}</Banner>}
                    {catalogueStatus === "ready" && !options.length && (
                        <p className="ft-sm text-gray-500">{translate("no_result")}</p>
                    )}
                    {catalogueStatus === "ready" && options.length > 0 && (
                        <ul className="flex flex-col gap-2 max-h-[45vh] overflow-y-auto" role="listbox" aria-label={translate("title")}>
                            {options.map((option) => {
                                const isSelected = option.key === selectedKey;
                                return (
                                    <li key={option.key} role="option" aria-selected={isSelected}>
                                        <button
                                            type="button"
                                            onClick={() => onSelect(option.key)}
                                            className={`w-full flex items-center justify-between gap-3 px-4 py-3 rounded-lg ft-b font-medium text-left ${
                                                isSelected ? "bg-yellow-500 text-white" : "bg-gray-100 text-gray-900 hover:bg-gray-200"
                                            }`}
                                        >
                                            <span>{getLabel(option)}</span>
                                            {isSelected && <Check wh={18} color={"#FFFFFF"}/>}
                                        </button>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button size={"LG"} color={"SECONDARY"} onClick={onClose}>
                    {translate("cancel")}
                </Button>
                <Button size={"LG"} color={canGoNext ? "PRIMARY" : "DISABLED"} disabled={!canGoNext} onClick={onNext}>
                    {translate("import_button")}
                </Button>
            </ModalFooter>
        </>
    );
};

export default LicenceCatalogueStep;
